<div class="navbar-fixed">
    <nav style="background-color: #ffffff; min-height: 85px">
        <div class="nav-wrapper">
           
            <a (click)="toggleMenu()" class="button-collapse hide-on-large-only menu-expand"><i class="material-icons expand-menu-icon" style="color: black;">menu</i></a>
            <a [routerLink]="['dashboard']" style=" float: left; margin-left: 4%; padding: 6px; color: black;">
                    <img class="logo" src="{{GETUri}}{{TTLogoImagePath}}" style="height: 80px; width: auto; " />
                </a>
            <ul class="right" style="color: black;">
                    
                <li>GET Inspector - {{userName}}</li>
                <li><a href="{{UCUri}}" style="color: black;">Undercarriage</a></li>
                <li><a href="{{GETUri}}safety/home" style="color: black;">Safety</a></li>
                <li><a href="http://help.tracktreads.com" target="_blank" style="color: black;">Help</a></li>               
                <li><a href="{{GETUri}}Account/SignOut" style="color: black;">Logout</a></li>
            </ul>
        </div>
    </nav>
</div>